import CONFIG from "@/assets/js/config.custom.js";

export default (user) => {
  if (user.admin_no) {
    user.loginType = 'admin';
  } else if (user.teacher_no) {
    user.loginType = 'teacher';
  } else {
    user.loginType = null;
  }

  if (user.loginType === 'teacher') {
    const currentRoles = ['newTeacher'];
    const TEACHER_ROLE = CONFIG.TEACHER_ROLE.ID;

    if (user.class_teacher_types?.some((t) => t.type == TEACHER_ROLE.HOMEROOM)) currentRoles.push("homeRoomTeacher");
    if (user.class_teacher_types?.some((t) => t.type == TEACHER_ROLE.ASSISTANT)) currentRoles.push("assistantTeacher");
    if (user.subject_teachers?.length > 0) currentRoles.push("subjectTeacher");

    user.roleLabels = currentRoles;
  } else if (user.loginType === 'admin') {
    let currentRole = null;
    const ROLE = CONFIG.ROLE.ID;
    const authUser = Number(user.role);
    const adminNo = user.admin_no;

    if (authUser === ROLE.STAFF) currentRole = "staff";
    else if (authUser === ROLE.ACCOUNTANT) currentRole = "accountant";
    else if (authUser === ROLE.LIBRARY_ADMIN) currentRole = "libraryAdmin";
    else if (authUser === ROLE.CLASS_MONITOR) currentRole = "classMonitor";
    else if (authUser === ROLE.OFFICE_ADMIN) currentRole = "officeAdmin";
    else if (authUser === ROLE.PRINCIPAL) currentRole = "principal";
    else if (authUser === ROLE.ACADEMIC_COORDINATOR) currentRole = "academicCoordinator";
    else if (authUser === ROLE.HR_OPERATOR) currentRole = "hrOperator";
    else if (authUser === ROLE.SUPER_ADMIN) currentRole = "superAdmin";
    else if (adminNo !== "0001") currentRole = "admin";
    else currentRole = "campusAdmin";

    user.roleLabel = currentRole;
  }

  return user;
}
